export default defineNuxtPlugin((nuxtApp) => {
  let scrollPosition = 0;



  // Function to lock the body scroll
  const lockBodyScroll = () => {
    scrollPosition = window.scrollY; // Store the current scroll position
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = "0px"
  };

  // Function to unlock the body scroll
  const unlockBodyScroll = () => {
    document.documentElement.style.overflow = "";
    document.documentElement.style.paddingRight = "" // Scroll back to the stored scroll position
  };

  nuxtApp.vueApp.directive("scroll-lock", {
    // When the element with the v-scroll-lock attribute is inserted into the DOM
    mounted(el, binding) {
      // Check if the directive value is true (e.g., v-scroll-lock="true")
      if (binding.value) {
        lockBodyScroll();
      }
    },
    // When the element with the v-scroll-lock attribute is updated
    updated(el, binding) {
      // Check if the directive value is true (e.g., v-scroll-lock="true")
      if (binding.value) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    },
    // When the element with the v-scroll-lock attribute is removed from the DOM
    unmounted() {
      unlockBodyScroll();
    },
  });
});
